import Vue from 'vue'
import Vuex from 'vuex'

import persistedState from 'vuex-persistedstate'

import authStore from './modules/auth'
import menusStore from './modules/menus'
import productsStore from './modules/products'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authStore: authStore,
    menus: menusStore,
    products: productsStore
  },
  plugins: [persistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js